angular.module("events")

.filter('limitUiSelect', function () {
    return function (input, limit, selectedItems, properties, selected, propertiesSelected) {
        if (!_.isArray(input) && !_.isString(input)) {
            return input;
        }
      
        if (limit >= 0) {
            //return input.filter(filterOutExisting).slice(0, limit);
            return filterOutExisting(input);
        } else {
            return input.slice(limit, input.length);
        }
        function filterOutExisting(item) {
            if (typeof properties !== 'undefined' && properties != "" && properties != null) {
                if (selectedItems == "" || selectedItems == null) {
                    //Para que preseleccione....
                    if (typeof propertiesSelected !== 'undefined' && propertiesSelected != "" && propertiesSelected != null) {
                        if (selected != null && selected != "" && typeof selected !== "undefined") {
                            return (item[propertiesSelected] != null ? item[propertiesSelected] === selected : item[propertiesSelected]); //!_.includes(selectedItems, item);

                        } else {
                            return input.slice(0, limit);
                        }
                    } 
                } else {
                    return item.filter(x => x[properties].toUpperCase().includes(selectedItems.toUpperCase()));
                    
                }
                
            } else {
                return item.filter(x => x[properties].toUpperCase().includes(selectedItems.toUpperCase()));
            }

        }
        
    };
})
